export default __webpack_public_path__ + "static/media/hero-customer.3b122759.svg";